import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom"; 
import './certificates.css'; 
import { MoonLoader } from "react-spinners";

const Certificates = () => {
  const [searchId, setSearchId] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const iframeRef = useRef(null); 

  const API_URL = "https://script.google.com/macros/s/AKfycbytyHkNZ8JBjfrHECaMk0yrpWfM9zvDelNBOc408pel5AvMORuxnn3287l9amEYuT6A/exec";

  useEffect(() => {
    const idFromUrl = searchParams.get("id");
    if (idFromUrl) {
      setSearchId(idFromUrl);
      fetchData(idFromUrl.toUpperCase()); 
    }
  }, [searchParams]);

  const handleSearch = () => {
    const trimmedSearchId = searchId.trim(); // Trim whitespace
  if (!trimmedSearchId) {
    setError("Please enter a valid Certificate ID before searching.");
    return;
  }
    const uppercaseId = searchId.toUpperCase(); 
    setSearchParams({ id: uppercaseId });
    fetchData(uppercaseId);
  };

  const fetchData = async (id) => {
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const response = await axios.get(`${API_URL}?cid=${id}`);
      if (response.data) {
        setResult(response.data);
      } else {
        setError("No results found.");
      }
    } catch (err) {
      console.error(err);
      setError("Error fetching data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  const downloadCertificate = () => {
  if (iframeRef.current) {
    const src = iframeRef.current.src;

    // Extract the Google Drive file ID from the src link
    const fileIdMatch = src.match(/\/d\/([a-zA-Z0-9_-]+)/);
    const fileId = fileIdMatch ? fileIdMatch[1] : null;

    if (fileId) {
      const directDownloadLink = `https://drive.google.com/uc?export=download&id=${fileId}`;
      const link = document.createElement("a");
      link.href = directDownloadLink;

      // Dynamically set the filename using Name and Event from the result
      const sanitizedEventName = result.Event.replace(/\s+/g, "_"); // Replace spaces with underscores
      link.download = `${result.Name}_${sanitizedEventName}.pdf`; // Custom filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error("Unable to extract file ID for direct download.");
    }
  }
};

  const getDriveIframeLink = (link) => {
    if (link.includes("drive.google.com")) {
      return link.replace("/view", "/preview");
    }
    return link;
  };

  return (
    <>
      <p className="certificates-header">Verify & Download Certificate</p>
      <div className="certificates-container">
        <div className="certificates-search-wrapper">
          <input
            type="text"
            placeholder="Enter Certificate ID"
            value={searchId}
            onChange={(e) => {
              setSearchId(e.target.value);
              setError(null); 
            }}

            onKeyDown={(e) => {
              if (e.key === 'Enter') { // Detect Enter key press
                e.preventDefault();  // Prevent default behavior (form submission, etc.)
                handleSearch();      // Call the search function
              }
            }}
            
          />
          <button onClick={handleSearch}>Search</button>
        </div>

        {loading && (
          <div className="certificates-spinner">
            <MoonLoader color="#007bff" size={50} />
            <p>Loading Certificate..</p>
          </div>
        )}

        {result && (
          <div className="certificate-card">
            <iframe
              className="certificates-iframe"
              src={getDriveIframeLink(result["Link"])}
              title="Google Drive Embed"
              ref={iframeRef} 
            ></iframe>

            <div className="certificate-details">
              <h3 className="typeheading" >Certificate of <span>{result.Type}</span></h3>
              
                 <hr></hr>
              
                <div className="info-card">
                  <div className="info-row">
                    <span className="info-label">Presented to:</span>
                    <span className="info-value">{result.Name}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">For:</span>
                    <span className="info-value">{result.Event}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Date Issued:</span>
                    <span className="info-value">{result.Date}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Certificate ID:</span>
                    <span className="info-value green">{result.Id}</span>
                  </div>
                  {result.By && (
                    <div className="info-row">
                      <span className="info-label">Issued By:</span>
                      <span className="info-value">{result.By}</span>
                    </div>
                  )}
                </div>

              <button className="download-button" onClick={downloadCertificate}>
                Download Your Certificate
              </button>
            </div>
          </div>
        )}

        {error && <p className="certificates-error-message">{error}</p>}
      </div>
    </>
  );
};

export default Certificates;
